// Reporter/surfacer cohort discriminator + the missing-surfacer view on top of
// it. A reporter row carries per-OP `comparisonCounts` instead of
// `findingsByOp`/detected_at_* — the backend `_worklist_row` returns one shape
// or the other, never both. "Is reporter" is the BASE concept; "has missed
// findings" (the missing-surfacer / missed-only lens) is a filter/view layered
// on top, so they're separate predicates rather than one conflated signal.
import type { StudyData } from "../components/types";
import { isPredictedNoise } from "../hooks/useSurfacerCandidates";

export function isReporterStudy(study: Pick<StudyData, "comparisonCounts">): boolean {
  return study.comparisonCounts != null;
}

// Curated surfacer-billable findings the report didn't address — the likely-real
// missed set (the prominent cards the SurfacerPanel shows, the worklist chip
// counts, the sort key). Excludes adjudicator-predicted noise
// (`report_mentions`/`no_report_coverage`), which sinks below the divider in the
// panel and is discounted here too so the worklist count + urgency match. 0 for a
// reporter study whose surfaced findings are all already-reported / not-covered
// (or whose report fully covered the AI's billable findings).
export function reporterMissedCount(study: Pick<StudyData, "surfacerFindings">): number {
  return (study.surfacerFindings ?? []).filter(
    (f) => !isPredictedNoise(f.predicted_verdict ?? null),
  ).length;
}
